import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const CloseMessageConfigRBAC = {
  pageID: 'de063533e35e69142746ca752a37f07e',
  elementID: {
    View: '59e1aef22e6d62c335e22bf286ea39d9',
    Delete: '2f3c36dee9a48c71d7bf86fbc3f6a18c',
    Edit: '09fa25120df62c43ab260248ea3c0e8f',
    Create: '9c54889a460f4df61473e25c86cd2be8',
  },
} as const

export const useCloseMessageConfigRBACPage = createUseRBAC(CloseMessageConfigRBAC.elementID)
export type UseCloseMessageConfigRBACPageType = ReturnType<typeof useCloseMessageConfigRBACPage>
